module.exports = __webpack_public_path__ + "static/media/grace_ma.5366c871.png";